module.exports = __webpack_public_path__ + "img/facebook.d4d64a31.svg";